import "./Footer.scss";
import moment from "moment";

const Footer = () => {
  return (
    <div className="notification-footer-wrapper">
      <div>Copyright by Maventech Labs Private Limited</div>
      <div>Generated On - {moment(new Date()).format('dddd, hh:mm, DD-MMM-YY')}</div>
      <div> </div>
    </div>
  );
};

export default Footer;